/*
 * Copyright(c) Oflane Software 2017. All Rights Reserved.
 */
import path from 'path'
/**
 * 后台请求工具
 * @author Paul.Yang E-mail:yaboocn@qq.com
 * @version 1.0 2017-7-13
 */

/**
 * get请求头信息
 * @type {{Accept: string, Content-Type: string}}
 */
const headers = {
  'Accept': 'application/x-www-form-urlencoded',
  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
}

/**
 *
 * @param data [Object] json格式的对象
 * @returns {string} 拼接好的formData格式字符串
 */
export const toParameters = (data, prefix = '') => prefix + Object.entries(data).map((k, v) => k + '=' + v).join('&')
/**
 * 增加rest请求的上下问路径
 * @param url {string} 请求地址
 * @return {string} 转换后路径
 */
export const getRestUrl = (url) => path.join(window.$restContext, url)
/**
 * rest 调用get请求
 * @param url {string} url串不带contextPath
 * @param params {object} 参数
 * @returns {Promise.<*>} 异步加载对象
 */
export const getJson = async (url, params = {}) => sendRequestJson(getRestUrl(url), params, 'GET')
/**
 * rest 调用get同步请求,返回json对象
 * @param url {string} url串不带contextPath
 * @param params {object} 参数
 * @returns {Promise.<*>} 异步加载对象
 */
export const getSyncJson = function*(url, params = {}) {
  if (!url) {
    throw new Error('url is null')
  }
  return yield sendRequestJson(getRestUrl(url), params, 'GET')
}
/**
 * rest 调用get请求
 * @param url {string} url串不带contextPath
 * @param params {object} 参数
 * @returns {Promise.<*>} 异步加载对象
 */
export const getText = async (url, params = {}) => sendRequestText(getRestUrl(url), params, 'GET')

/**
 * rest 调用get同步请求返回文本
 * @param url {string} url串不带contextPath
 * @param params {object} 参数
 * @returns {Promise.<*>} 异步加载对象
 */
export const getSyncText = function*(url, params = {}) {
  if (!url) {
    throw new Error('url is null')
  }
  return yield sendRequestText(getRestUrl(url), params, 'GET')
}
/**
 *
 * @param url [String] 请求地址
 * @param params [Object] 携带的数据
 * @param type [String] 方法 默认'get'支持'post'、'delete'
 * @returns {Promise.<*>}
 */
export const sendRequestJson = (url, params = {}, type = 'GET') => sendRequest(url, params, type)

/**
 *
 * @param url [String] 请求地址
 * @param params [Object] 携带的数据
 * @param type [String] 方法 默认'get'支持'post'、'delete'
 * @returns {Promise.<*>}
 */
export const sendRequestText = async (url, params = {}, type = 'GET') => {
  let res = sendRequest(url, params, type)
  return await res.text()
}
/**
 *
 * @param url [String] 请求地址
 * @param params [Object] 携带的数据
 * @param type [String] 方法 默认'get'支持'post'、'delete'
 * @returns {Promise.<*>}
 */
export const sendRequest = async (url, params = {}, type = 'GET') => {
  if (!url) {
    throw new Error('url is null')
  }
  if (type.toUpperCase() === 'GET') {
    const length = Object.keys(params).length
    if (length) {
      url = `${url}${toParameters(params, '?')}`
    }
  }
  let requestConfig = {
    credentials: 'include',
    method: type,
    headers,
    mode: 'cors',
    cache: 'force-cache'
  }
  if (type.toUpperCase() === 'POST') {
    Object.defineProperty(requestConfig, 'body', {
      value: toParameters(params)
    })
  }
  try {
    let res = await fetch(url, requestConfig)
    let json = await res.json()
    return json
  } catch (error) {
    throw new Error(error)
  }
}



// WEBPACK FOOTER //
// ./src/utils/rest.js